import HomeModel from '@/models/Home';

const HOME_PAGE_BY_CODE = "HOME_PAGE_BY_CODE"
const PRICING_MODELS = "PRICING_MODELS"
const PRICING_PLANS = "PRICING_PLANS"


// 首页看板预览
async function queryHomePageByCode(code) {
    const payload = await new HomeModel().queryHomePageByCode(code);
    return {
        type: HOME_PAGE_BY_CODE,
        payload
    }
}

async function querySubscriptionPlans(params = {}) {
    const payload = await new HomeModel().querySubscriptionPlans(params);
    return {
        type: PRICING_PLANS,
        payload
    }
}

async function queryPricingModels(params = {}) {
    const payload = await new HomeModel().queryPricingModels(params);
    return {
        type: PRICING_MODELS,
        payload
    }
}

const ACTION_TYPES = {
    HOME_PAGE_BY_CODE,
    PRICING_MODELS,
    PRICING_PLANS
};

const ACTION = {
    queryHomePageByCode,
    queryPricingModels,
    querySubscriptionPlans
};

const Home = {
    ACTION_TYPES,
    ACTION
}

export default Home;